import { Box, Stack, Typography, useTheme } from "@mui/material";
import { getClickableProps } from "src/utils/keyboard-utils";
import { useConfiguratorPageT } from "src/translation-hooks/configurator-page";
import { TProductTypeLine } from "../../bulk-configure-products-utils";

type Props = {
  lines: TProductTypeLine[];
  selectedProductTypeId?: string;
  onSelect: (productTypeId: string) => void;
};

// Rows are product types rather than line items, but styled to match ProductLineItemRow.
export const ProductTypeListSection = (props: Props) => {
  const { lines, selectedProductTypeId, onSelect } = props;

  const theme = useTheme();
  const configuratorPageT = useConfiguratorPageT();

  return (
    <Stack gap={4}>
      <Typography variant="h2" fontWeight="500" color={theme.palette.primary.contrastText}>
        {configuratorPageT.editProducts}
      </Typography>

      <Stack gap={1}>
        {lines.map(line => {
          const isSelected = line.productTypeId === selectedProductTypeId;

          return (
            <Box
              key={line.productTypeId}
              {...getClickableProps(() => onSelect(line.productTypeId))}
              onClick={() => onSelect(line.productTypeId)}
              sx={{
                position: "relative",
                display: "flex",
                alignItems: "center",
                width: "100%",
                p: 1,
                cursor: "pointer",
                outline: "none",
                borderRadius: 1,
                border: isSelected ? `1px solid ${theme.palette.customColors.whiteBorderStrong}` : "none",
                bgcolor: isSelected ? theme.palette.customColors.darkGreen : theme.palette.customColors.green,
                color: theme.palette.primary.contrastText,
                "&:focus-visible": { outline: `2px solid ${theme.palette.primary.contrastText}` },
                "&:hover": { backgroundColor: `${theme.palette.customColors.black}26` }
              }}
            >
              <Typography variant="subtitle2" fontWeight="500" flex={1} overflow="hidden" textOverflow="ellipsis" whiteSpace="nowrap">
                {line.productTypeName}
              </Typography>
              <Typography variant="caption" flexShrink={0} ml={1}>
                {line.productIds.length}
              </Typography>
            </Box>
          );
        })}
      </Stack>
    </Stack>
  );
};
